function randomNumber(start,end){
  if (arguments.length === 2) {
      return Math.round(start + Math.random() * (end - start));
  }
  else if (arguments.length === 1) {
      return Math.round(Math.random() * start)
  }
  else {
      return Math.round(Math.random() * 100)
  }
}
function trimText(str, type="all") {
    switch (type) {
        case 'all':
            return str.replace(/\s+/g, "");
        case 'around':
            return str.replace(/(^\s*)|(\s*$)/g, "");
        case 'left':
            return str.replace(/(^\s*)/g, "");
        case 'right':
            return str.replace(/(\s*$)/g, "");
        default:
            return str.replace(/\s+/g, "");
    }
}
//使用的 时候注意 v-html
function emphasizeText(text, keyword, className = 'highlight-text'){
  if (!keyword) return text;
  else{
    var reg = new RegExp(keyword, 'ig');
    return text.replace(reg, `<span class="${className}">${keyword}</span>`);
  }
}
function numLessTen(str){
  return parseInt(str)<10?'0'+str : str;
}

function addClass(obj, cls){
    var obj_class = obj.className,
        blank = (obj_class != '') ? ' ' : '';
    var added = obj_class + blank + cls;
    obj.className = added;
}
function removeClass(obj, cls){
    var obj_class = ' '+obj.className+' ';
    obj_class = obj_class.replace(/(\s+)/gi, ' ');
    var removed = obj_class.replace(' '+cls+' ', ' ');
    removed = removed.replace(/(^\s+)|(\s+$)/g, '');
    obj.className = removed;
}
function hasClass(obj, cls){
    var obj_class = obj.className,
        obj_class_lst = obj_class.split(/\s+/);
    var x = 0;
    for(x in obj_class_lst) {
        if(obj_class_lst[x] == cls) {
            return true;
        }
    }
    return false;
}
function getId(id){
	 return document.getElementById(id);
}
//分享
require("emf");
require("emf/src/js/util/util-nativepi");
function shareFun(pageTitle,shareTitle,shareDesc,shareUrl){
  if (AG.InApp) {
      //确定标题
      AG.setTitle(pageTitle);
      AG.emH5ShareNeed(1);
	  //alert(JSON.stringify(shareUrl));
      //分享
      window.emH5ShareInfo = function() {
        var jsonStr = {
          callbackname: "callbackShare",
          type: "weixin,pengyouquan,weibo,message,email",
          title: shareTitle,
          img: "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png",
          url: shareUrl,
          desc: shareDesc
        };

        AG.eventShare(jsonStr);
      }
    }
	else {
		emH5.Share({
		title: shareTitle,
		desc: shareDesc,
		link: shareUrl,
		imgUrl: "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png"
	  });
    }
}
//跳转分时图
function intoStockNativePage(stockName, stockCode, marketCode){
	 if (AG.InApp) {
		var jsonStr =
		  '{"stockName": "' + stockName + '","stockCode": "' + marketCode +"|"+ stockCode + '"}';
		if (AG.ISIOS) {
		  window.location = "emH5ToNativePage:" + jsonStr;
		} else {
		  eastmoney.emH5ToNativePage(jsonStr);
		}
	 }
	 else {
		location.href = "http://m2.quote.eastmoney.com/h5stock/" + stockCode + "5.html";
	 }
}

module.exports = {
  randomNumber,
  trimText,
  emphasizeText,
  numLessTen,
  addClass,
  removeClass,
  hasClass,
  getId,
  shareFun,
  intoStockNativePage
}



// WEBPACK FOOTER //
// ./src/utils/tool.js